import { render } from "./AuthorLine.vue?vue&type=template&id=36de894b&scoped=true"
import script from "./AuthorLine.vue?vue&type=script&lang=js"
export * from "./AuthorLine.vue?vue&type=script&lang=js"

import "./AuthorLine.vue?vue&type=style&index=0&id=36de894b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36de894b"]])

export default __exports__